module.exports = "<ng-content select=\"[content]\"></ng-content>\n<div class=\"c-container-rollover-actions__content\">\n\t<ng-content select=\"[actions]\"></ng-content>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/container-rollover-actions/container-rollover-actions.component.html
// module id = ./src/app/modules/common-module/components/container-rollover-actions/container-rollover-actions.component.html
// module chunks = 9